/**
 * /r/:code — stash the ref code in localStorage + forward to /register so the
 * referrer attribution survives even if the visitor signs up later.
 */
import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";

export default function ReferralRedirect() {
  const { code } = useParams();
  useEffect(() => {
    if (code) localStorage.setItem("af_ref_code", code.toUpperCase());
  }, [code]);
  return <Navigate to={`/register?ref=${(code || "").toUpperCase()}`} replace />;
}
